<tt-page *ngIf="!!setting">
    <ng-container *ngIf="tabletSize.matches; else mobileView">
        <tt-card *ngIf="itemState === 'p2updateprocedureedit'" class="col-xs-12 col-md-9 p-5" ttHeading="h_update_procedures"></tt-card>

        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-6 p-5">
                <tt-input ttRememberId="w_p2updateprocedures.searchtext" ttLabel="searchtext" ttFocus [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
            </tt-card>

            <tt-card class="col-xs-12 col-md-3 p-5">
                <tt-button ttText="register_new_p2_updateprocedure" ttTextAlign="left" ttIcon="fas fa-plus" (ttClick)="createProcedure($event)"></tt-button>
            </tt-card>
        </div>

        <ng-container *ngIf="itemState !== 'p2updateprocedureedit'; else inlineEditor">
            <tt-list [ttData]="procedures" [ttFilter]="setting.searchtext" (ttClick)="openProcedure($event.item, $event.event)"></tt-list>
        </ng-container>

        <ng-template #inlineEditor>
            <tt-divider ttRememberId="p2updateprocedures_dividers">
                <tt-divider-columns>
                    <tt-divider-pane ttSize="50">
                        <tt-list class="col-xs-12 p-5" [ttData]="procedures" [ttFilter]="setting.searchtext" (ttClick)="openProcedure($event.item, $event.event)"></tt-list>
                    </tt-divider-pane>

                    <tt-divider-pane ttSize="50">
                        <tt-p2-update-procedure-edit *ngIf="selectedProcedureKeyno !== ''" class="col-xs-12 p-5" [p2UpdateProcedureKeyno]="selectedProcedureKeyno" [inline]="true" (onSave)="updateList()"></tt-p2-update-procedure-edit>
                    </tt-divider-pane>
                </tt-divider-columns>
            </tt-divider>
        </ng-template>
    </ng-container>

    <ng-template #mobileView>
        <tt-card class="col-xs-12 sp-0">
            <tt-input ttRememberId="w_p2updateprocedures.searchtext" ttLabel="searchtext" ttFocus [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
            <tt-button-goto
                ttText="register_new_p2_updateprocedure"
                ttGoto="p2updateprocedureedit"
                [ttGotoParms]="{ p2_updateprocedure_keyno: '0' }"
                ttTextAlign="left"
                ttIcon="fas fa-plus">
            </tt-button-goto>
        </tt-card>

        <tt-list [ttData]="procedures" [ttFilter]="setting.searchtext" (ttClick)="openProcedure($event.item, $event.event)"></tt-list>
    </ng-template>
</tt-page>
